<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="normal"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>编辑</template>
    <template #content>
      <el-form
          ref="form"
          :model="form"
          @submit.native.prevent
          label-width="80px">
        <el-form-item
            label="品牌名称"
            prop="name"
            :rules="[
              { required: true, message: '请输入品牌名称', trigger: ['blur', 'change'] },
              { max: 60, message: '长度不能大于60个字符', trigger: ['blur', 'change'] }
            ]">
          <gj-input
              v-model="form.name"
              class="form-input"
              width="100%"
          ></gj-input>
        </el-form-item>
        <el-form-item
            label="描述"
            prop="memo"
            style="margin-bottom: 0;">
          <gj-textarea
              v-model="form.memo"
              :styles="{height: '120px', width: '100%'}"
              class="form-input">
          </gj-textarea>
        </el-form-item>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn} from "../../../../../minxins";
  import {updateProductBrand} from "../../../../../api/product";
  import {defaultVal} from "../../../../../utils/common";

  export default {
    name: "app-product-brand-edit-modal",
    mixins: [modalMixIn],
    props: {
      brand: {
        required: true
      }
    },
    created() {
      this.form.name = this.brand.name;
      this.form.memo = this.brand.memo;
    },
    data() {
      return {
        confirmLoading: false,
        form: {
          name: null,
          memo: null
        }
      }
    },
    methods: {
      confirm() {
        this.confirmLoading = true;
        this.$refs.form.validate((valid) => {
          if (valid) {
            updateProductBrand({
              id: this.brand.id,
              name: this.form.name,
              memo: defaultVal(this.form.memo, null),
            })
              .then(() => {
                this.$emit('updated');
                this.$gjDestroy();
              })
              .complete(() => this.confirmLoading = false);
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-dialog__body{
     padding-bottom: 0;
   }
</style>
